export default __webpack_public_path__ + "static/media/grid-view.22993b9f.svg";